import React from 'react';
import toast from 'react-hot-toast';
import { downloadAudioFile } from '../../../../services/musicAudioService';
import AudioPlayer from '../../../common/AudioPlayer';
import EmptyState from './EmptyState';

export default function MusicResult({ music, t, cost, onRegenerate }) {
  if (!music) {
    return (
      <EmptyState
        type="music"
        title={t('videoGeneration.mv.preview.emptyMusicTitle')}
        desc={t('videoGeneration.mv.preview.emptyMusic')}
        hint={t('videoGeneration.mv.preview.emptyMusicHint')}
      />
    );
  }
  const onDownload = async () => {
    try {
      await downloadAudioFile(music.downloadUrl || music.audioUrl);
    } catch (error) {
      toast.error(t('videoGeneration.mv.actions.downloadFailed'));
    }
  };
  return (
    <div className="mv-result mv-result--music">
      <AudioPlayer music={music} t={t} />
      <div className="mv-next">
        <div><strong>{t('videoGeneration.mv.preview.musicTitle')}</strong><span>{music.meta}</span></div>
        <div className="mv-actions">
          <button onClick={onRegenerate}>{t('videoGeneration.mv.actions.regenerateWithCredits', { count: cost })}</button>
          <button disabled={!music.downloadUrl && !music.audioUrl} onClick={onDownload}>{t('videoGeneration.mv.actions.download')}</button>
        </div>
      </div>
    </div>
  );
}
